import {Dimensions} from 'react-native'

const smallFormatIPhoneHeightThreshold: number = 800

const {height} = Dimensions.get('window')

export const isTinyScreen = height < smallFormatIPhoneHeightThreshold
